// imports section Start
import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
// imports section End
function DynamicLineChart({ dataset = null }) {
  return (
    <>
      {dataset ? (
        <LineChart
          dataset={dataset}
          xAxis={[
            {
              dataKey: "x",
              type: "time",
              valueFormatter: (value) => {
                return new Date(value).toLocaleDateString("en-GB");
              },
            },
          ]}
          series={[{ dataKey: "y" }]}
          height={300}
          margin={{ left: 30, right: 30, top: 10, bottom: 30 }}
          grid={{ vertical: true, horizontal: true }}
        />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default DynamicLineChart;
